import React, { useEffect } from "react";
import PaymentPageHeader from "../../Component/PaymentPageHeader/PaymentPageHeader.jsx";
import PaymentPageSidebar from "../../Component/PaymentPageSidebar/PaymentPageSidebar.jsx";
import Footer from "../../Component/Footer/Footer.jsx";
import UpdateMembershipService from "./UpdateMembershipService.js";
import { RingLoader } from "react-spinners";

const UpdateMembership = () => {
  const {
    getUpdatedMembership,
    loading,
    updatedMembData,
    itemsPerPage,
    currentPage,
    setCurrentPage,
    handleCouponClick,
    couponData,
    couponPopup,
    setCouponPopup,
  } = UpdateMembershipService();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = updatedMembData?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(updatedMembData?.length / itemsPerPage);

  useEffect(() => {
    getUpdatedMembership();
  }, []);
  return (
    <>
      <PaymentPageHeader />
      <div className="main-container">
        <div className="main-wrapper">
          <PaymentPageSidebar />
          <div className="main-content ">
            <div className="transactions-web-wrapper">
              <div className="header-section">
                <p className="transactions-heading">Membership &amp; Type</p>
              </div>
              <div className="transactions-table-container">
                <div className="head-section">
                  <p className="payment-heading">Choose Membership Type</p>
                </div>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "400px",
                  }}
                >
                  <table className="transactions-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>MembershipType</th>
                        <th>CouponCount </th>
                        <th>CouponValue</th>
                        <th>Description</th>
                        <th>ValidityInDays</th>
                        <th>Cost</th>
                        <th>Purchase</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8">
                            <div className="loader">
                              <RingLoader color="#5a6876" size={50} />
                            </div>
                          </td>
                        </tr>
                      ) : currentData?.length > 0 ? (
                        currentData.map((item, index) => (
                          <tr className="transaction-item" key={index}>
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>
                              {item?.memberShipType}
                              <span>
                                {item?.isCouponAllowed && (
                                  <button
                                    style={{
                                      marginLeft: "8px",
                                      padding: "2px 6px",
                                      fontSize: "12px",
                                      cursor: "pointer",
                                      background: "grey",
                                    }}
                                    onClick={() => handleCouponClick(item?.id)}
                                  >
                                    Coupons
                                  </button>
                                )}
                              </span>
                            </td>
                            <td>{item?.couponCount}</td>
                            <td>{item?.couponValue}</td>
                            <td>{item?.remark}</td>
                            <td>{item?.couponValidityDays}</td>
                            <td>{item?.cost}</td>
                            <td>
                              {item?.isPurchase ? (
                                <img
                                  src="/assets/pwa-static/pwa/images/icons/tick1.png"
                                  alt="Yes"
                                  style={{ width: "20px", height: "20px" }}
                                />
                              ) : (
                                <img
                                  src="/assets/pwa-static/pwa/images/icons/cross.png"
                                  alt="No"
                                  style={{ width: "20px", height: "20px" }}
                                />
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: "center" }}>
                            !!! &#128528; &#128528; No Data found &#128528;
                            &#128528;!!!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="pagination-buttons">
                  <ul class="pagination">
                    <li class="page-item">
                      <button
                        onClick={() =>
                          setCurrentPage((p) => Math.max(1, p - 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    <li class="page-item">
                      <div>
                        {currentPage} of {totalPages}
                      </div>
                    </li>
                    <li class="page-item">
                      <button
                        onClick={() =>
                          setCurrentPage((p) => Math.min(totalPages, p + 1))
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {couponPopup && (
        <>
          <div className="modal-overlay">
            <div className="modal-content">
              <button onClick={() => setCouponPopup(false)}>&times;</button>

              <div className="transactions-table-container">
                <div className="head-section">
                  <p className="payment-heading">Coupon List</p>
                </div>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "400px",
                  }}
                >
                  <table className="transactions-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>CouponCode</th>
                        <th>CouponValue</th>
                        <th>CouponExpiry</th>
                        <th>RedeemDate</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6">
                            <div className="loader">
                              <RingLoader color="#5a6876" size={50} />
                            </div>
                          </td>
                        </tr>
                      ) : couponData?.length > 0 ? (
                        couponData.map((item, index) => (
                          <tr className="transaction-item" key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.CouponCode}</td>
                            <td>{item?.CouponValue}</td>
                            <td>{item?.CouponExpiry}</td>
                            <td>{item?.RedeemDate}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" style={{ textAlign: "center" }}>
                            !!! 😐 😐 No Data found 😐 😐 !!!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UpdateMembership;
